export const Diamond = () => <span className="section-dot" aria-hidden="true" />;

export default function Logo({ testId }) {
    return <span className="wordmark" data-testid={testId}>DECORCRAFTS</span>;
}